export default __webpack_public_path__ + "static/media/products_413.718cfe78.jpg";